import { MarcacionConfigResponse, MarcacionOpcionFE } from '../types';

// SPEC-206 (ADR-004, TC-035) — al recargar el Detalle reconstruye la caché de opciones de una
// marcación confirmada por tarifa ('minima'/'rango'): las de la misma categoría y, en tarifas por
// tinta, del mismo número de tintas que la opción guardada. Mismo filtro que MarcacionModal.
export function opcionesHermanasDe(config: MarcacionConfigResponse, opcionId: number): MarcacionOpcionFE[] {
  const opcion = config.opciones.find((o) => o.id === opcionId);
  if (!opcion) return [];
  return config.opciones.filter(
    (o) => o.categoria === opcion.categoria && (config.config.tipoVariable !== 'por_tinta' || o.numTintas === opcion.numTintas),
  );
}
